import Server from "../server";
import View from "../framework/view";
import template from "../../pugc/login";
import JQuery from "jquery";
import {formToJson} from "../misc/utils";
import Alerts from "../misc/alerts";
import {App} from "../app/app";

export class LoginView extends View {

    static classname = "login-view";

    private readonly server = Server.instance();

    private app : App;

    constructor(app: App) {
        super(LoginView.classname);
        this.app = app;
    }

    protected render0(): JQuery<HTMLElement> {
        const data = {
        };

        const out = this.pug(template, data);
        out.find(".with-validation").validate({
            rules: {
                username: "required",
                password: "required",
            }
        });

        return out;
    }

    login() {
        const form = this.elt().find(".login-form");

        if (! form.valid()) {
            return;
        }

        const data : { username?: string, password?: string } = {};
        formToJson(form, data);

        this.server.login(data).then((user) => {

            if (user) {

                this.app.setUser(user);

                window.location.hash = "/home";

            } else {
                // Problems
                Alerts.alert("Login failed");
            }
        });

    }


}

View.on(
    "." + LoginView.classname,
    "click",
    ".login",
    function(that: LoginView, event, elt) {
        event.preventDefault();
        that.login();
    });

